module.exports = __webpack_public_path__ + "img/116.e63a96b8.jpg";